module.exports = __webpack_public_path__ + "cfb0937342200d5bea051da9dc3fd2fd.fbx";